import { isWithinInterval, addDays, isAfter, startOfToday } from 'date-fns'
import { BookingVaccination } from 'types/apiModels'

// How far into the future our vaccinations should be defined as active
export const ACTIVE_DAYS = 3

// Filter out active vaccinations
export function filterActiveVaccinations(vaccinations: BookingVaccination[]) {
  const isActiveVaccination = (vaccinationDate: string | undefined) => {
    if (vaccinationDate == null) {
      return false
    }
    return isWithinInterval(new Date(vaccinationDate), {
      start: startOfToday(),
      end: addDays(startOfToday(), ACTIVE_DAYS),
    })
  }

  const activeVaccinations = vaccinations?.filter((vaccination: BookingVaccination) =>
    isActiveVaccination(vaccination.start_time),
  )

  return activeVaccinations
}

// Filter out future vaccinations
export function filterFutureVaccinations(vaccinations: BookingVaccination[]) {
  return vaccinations?.filter((vaccination) => {
    if (vaccination.start_time == null) {
      return false
    }

    return isAfter(new Date(vaccination.start_time), addDays(startOfToday(), ACTIVE_DAYS))
  })
}
